export const types = {
    CALLAUTOM: 'CALL-AUTOM'
};